import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/produto')({
    beforeLoad: () =>
        validateRoute({
            fintech: true,
            validatePermission: ({ upp_cadastro_produto }) =>
                isPermissionParcialOrFull(upp_cadastro_produto),
        }),
});
